import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { SeOrgFilestoreComponent } from "../se.org.filestore.component";
@Component({
    standalone: true,
    selector: "s25-ng-se-org-files-widget",
    template: `
        @if (orgStore.orgId()) {
            <se-org-filestore [orgId]="orgStore.orgId()!" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [SeOrgFilestoreComponent],
})
export class SeOrgFilesWidgetComponent extends LayoutWidget<typeof SeOrgFilesWidgetComponent> {
    static readonly META = {
        name: "Files",
        info: "Displays the organization file storage. Requires file access permission.",
        /** Requires SE_ORG_FILESTORE Read access. The renderer shows a locked block when this is false. */
        flsFloor: "canViewOrgFilestore",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);
}
